import { render } from "./AddCastrStreamModal.vue?vue&type=template&id=8b9898ce&scoped=true"
import script from "./AddCastrStreamModal.vue?vue&type=script&lang=js"
export * from "./AddCastrStreamModal.vue?vue&type=script&lang=js"

import "./AddCastrStreamModal.vue?vue&type=style&index=0&id=8b9898ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9898ce"]])

export default __exports__